export const greetingDefaultMessage = 'Hey, {firstName}!';
export const candidateRequestDefaultMessage = `{firstName} {lastName} has listed you as a reference related to
a new job opportunity`;
export const greetQuestionDefaultMessage = `Are you willing to complete a short survey about your work experience
with {firstName}?`;
export const welcomeInfo1 = 'Your responses will ';
export const welcomeInfo2 = ' be shared with {firstName}.';
export const not = 'not';

export const privacyContentLabel = 'Some quick housekeeping...';
export const privacyContent1 = `I understand that {candidate} provided {customer} and KodiakHR my personal
contact information to conduct a reference check. I understand that {candidate} signed a waiver to release
me from any liability arising from information I provide.{breakingLine}{breakingLine}I authorize {customer} 
and KodiakHR to contact me directly via email and / or SMS text message for the purposes of this reference 
check.{breakingLine}{breakingLine}`;
export const privacyContent2 = `My responses to the following questions reflect my own personal views and
not those of my current or former employer. I voluntarily release my current or former employer from any
liability arising from information I provide.{breakingLine}{breakingLine}My responses to the following
questions are truthful.{breakingLine}{breakingLine}`;

export const termsOfUse1 = 'I agree to the above and to KodiakHR’s';
export const termsOfUse2 = 'Terms of Service';

export const declineQuestion1 = 'Are you declining to answer due to a company policy?';
export const declineQuestion2 = 'Ok, can you please tell us why you decline to answer?';
export const declinePolicy1 = `We understand that some companies have policies that limit reference checks.
However, the following survey is a `;
export const declinePolicy2 = 'personal';
export const declinePolicy3 = ` reference check.{breakingLine}{breakingLine}That means your answers
are yours alone and you are `;
export const declinePolicy4 = ' speaking on behalf of your current or former employer.';
export const declinePlaceholder = 'Enter response here';
export const termsLink = 'https://www.kodiakhr.com/legal/terms-of-service';
